import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';

import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import type { IKeywordStats } from './KeywordStatsTableCard';

interface IRow {
  original: IKeywordStats;
}

function getClickThroughRate(stats: IKeywordStats): string {
  return numeral(stats.num_clicks / stats.num_views).format('0.00%');
}

function getCostPerClick(stats: IKeywordStats): string {
  return numeral(stats.spend / stats.num_clicks).format('$0.00');
}

export const KeywordStatsColumns: Array<IColumn<IKeywordStats>> = [
  {
    Header: TableColumnHeader({ title: 'Keyword' }),
    id: 'keywords',
    Cell({ original }: IRow): JSX.Element {
      return <>{original.term}</>;
    },
  },
  {
    Header: TableColumnHeader({ title: 'Views' }),
    id: 'views',
    Cell({ original }: IRow): JSX.Element {
      return <>{numeral(original.num_views).format('0,0')}</>;
    },
  },
  {
    Header: TableColumnHeader({ title: 'Clicks' }),
    id: 'clicks',
    Cell({ original }: IRow): JSX.Element {
      return <>{numeral(original.num_clicks).format('0,0')}</>;
    },
  },
  {
    Header: TableColumnHeader({ title: 'Click Through Rate' }),
    id: 'clickThroughRate',
    Cell({ original }: IRow): JSX.Element {
      return <>{getClickThroughRate(original)}</>;
    },
  },
  {
    Header: TableColumnHeader({ title: 'Cost Per Click' }),
    id: 'costPerClick',
    Cell({ original }: IRow): JSX.Element {
      return <>{getCostPerClick(original)}</>;
    },
  },
];
